import { Component, Input, OnInit } from '@angular/core';
import { IBreadcrumbData } from '../../interfaces/breadcrumb-data.interface';
import { ConfigService } from '../../services/config.service';
import { WebSocketService } from '../../services/web-socket.service';

/**
 * BreadcrumbComponent
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  /**
   * BreadcrumbData
   */
  @Input() data: IBreadcrumbData;

  /**
   * Status data
   */
  @Input() servmatData: string;

  /**
   * Status data
   */
  @Input() statusData: string;

  /**
   * Status data
   */
  @Input() comServerData: string;

  /**
   * Status data
   */
  @Input() authServerData: string;

  /**
   * Status data
   */
  @Input() ocrServerData: string;

  /**
   * Status data
   */
  @Input() syncroStatus: string;

  /**
   * Status action
   */
  @Input() syncroAction: any;

  /**
   * Constructor
   */

  /**
   * Constructor
   */
  constructor(private wsService: WebSocketService, private config: ConfigService) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {}

  /**
   * Send action to execute
   *
   * @param action Function to execute
   */
  sendAction(action: () => void): void {
    action();
  }

  restart(server) {
    let host = null;
    let serverName = null;
    switch (server) {
      case 'Servmat':
        serverName = 'Servmat';
        server = 'server';
        host = this.config.config.server.IP;
        break;
      case 'authServer':
        serverName = 'authServer';
        server = 'auth_server';
        host = this.config.config.auth_server.IP;
        break;
      case 'comServer':
        serverName = 'comServer';
        server = 'com_server';
        host = this.config.config.com_server.IP;
        break;
    }
    this.wsService.send('restart', { server, host, serverName });
    console.log(`reiniciando ${server}...`);
    // window.open('file:///c:/masterJS/prueba.bat');
  }
}
